module.exports = __webpack_public_path__ + "static/media/team_task.cbc0eb65.png";